import { useState } from 'react';
import { isInIframe } from '../services/iframeAuth';

/**
 * Hook pour détecter si l'application s'exécute dans une iframe.
 *
 * Important : on initialise le state via lazy init avec `isInIframe()` (synchrone)
 * pour que la valeur soit correcte DÈS LE PREMIER RENDER. Sinon, des composants
 * qui réagissent à `isInIframe` dans un useEffect (ex: Layout.tsx redirige vers
 * /api/login si !isInIframe) pourraient agir sur la valeur false par défaut
 * AVANT qu'un useEffect de mise à jour ait pu corriger la valeur — ce qui en
 * iframe non-Teams provoquerait une redirection Keycloak parasite (bloquée par
 * frame-ancestors côté Keycloak).
 *
 * @returns true si dans une iframe, false sinon
 */
export function useIsInIframe(): boolean {
  const [inIframe] = useState<boolean>(() => isInIframe());
  return inIframe;
}

export default useIsInIframe;
